"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sanitizeHTML = void 0;
var _dompurify = _interopRequireDefault(require("dompurify"));
const sanitizeHTML = htmlString => {
  return _dompurify.default.sanitize(htmlString);
};
exports.sanitizeHTML = sanitizeHTML;